export default __webpack_public_path__ + "static/404-2f6c7c2e7d3015f011dc76ab445be760.webp";